module.exports = __webpack_public_path__ + "static/media/Powered_by_blue.69c397c4.png";